/**
 * Laney funnel page, ported from public/preview/laney.html.
 *
 * Kept from the original: gallery feed/thumb/dot/peek sync, tier picking with
 * hero-image swap, buy-it-with totals, sticky ATC, countdowns, toast, the
 * silver photo filter.
 *
 * Replaced from the original: everything cart-shaped. The source page wrote a
 * sessionStorage cart and handed off to the custom site's checkout — none of
 * which exists on Shopify. Add-to-bag here POSTs real variant IDs to
 * /cart/add.js; UpCart (the store's cart drawer) intercepts that request and
 * opens itself. Bundle prices shown on the page are honored at checkout by an
 * automatic "buy 2+, 20% off" discount configured in Admin, NOT by this code —
 * Shopify does not allow a theme to set line prices.
 */
(function () {
  var root = document.querySelector('.lc-funnel');
  if (!root) return;

  /* ---------- image fallback ---------- */
  var PH = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">' +
    '<rect width="400" height="400" fill="#f4ead9"/>' +
    '<circle cx="200" cy="185" r="42" fill="#efe3ce"/>' +
    '<text x="200" y="290" text-anchor="middle" font-family="Georgia" font-size="19" fill="#b08d57" letter-spacing="4">LOUISE CARTER</text></svg>');
  window.phFix = function (img) { if (img.src !== PH) { img.src = PH; } };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  window.toast = toast;

  /* ---------- gallery (server-rendered; JS only syncs) ---------- */
  var heroFeed = document.getElementById('heroFeed');
  var peekTrack = document.getElementById('peekTrack');
  var feedImgs = heroFeed ? Array.prototype.slice.call(heroFeed.querySelectorAll('img')) : [];
  var gIdx = 0;
  /* The lead photo as served, before any variant swap — restored when the
     shopper returns to a variant that has no photo of its own (e.g. gold,
     whose look IS the product's default photography). */
  var defaultHero = feedImgs.length ? feedImgs[0].src : null;
  /* The picked variant's own photo, when it has one; solo-tier picks show it. */
  var lastVariantImg = null;

  function syncGallery(i) {
    root.querySelectorAll('.thumbs button').forEach(function (x, k) { x.classList.toggle('active', k === i); });
    root.querySelectorAll('.dots i').forEach(function (x, k) { x.classList.toggle('on', k === i); });
  }
  function showImage(src) {
    /* Desktop feed and the mobile peek carousel are separate DOM; a hero
       swap must hit both or the change is invisible on one breakpoint. */
    if (feedImgs.length) {
      var f = feedImgs[0];
      f.src = src;
      f.onerror = function () { phFix(f); };
      heroFeed.scrollTo({ top: 0, behavior: 'smooth' });
    }
    var pf = document.getElementById('peekFeatured');
    if (pf) {
      pf.src = src;
      pf.onerror = function () { phFix(pf); };
      if (peekTrack) peekTrack.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }
  window.setHero = function (i) {
    if (!feedImgs.length) return;
    gIdx = (i + feedImgs.length) % feedImgs.length;
    heroFeed.scrollTo({ top: feedImgs[gIdx].offsetTop, behavior: 'smooth' });
    syncGallery(gIdx);
    var tag = document.getElementById('heroTag');
    if (tag) tag.classList.remove('on');
  };
  if (heroFeed) {
    var feedTicking = false;
    heroFeed.addEventListener('scroll', function () {
      if (feedTicking) return;
      feedTicking = true;
      requestAnimationFrame(function () {
        gIdx = Math.min(feedImgs.length - 1, Math.round(heroFeed.scrollTop / heroFeed.clientHeight));
        syncGallery(gIdx);
        feedTicking = false;
      });
    }, { passive: true });
  }
  if (peekTrack) {
    var peekTicking = false;
    peekTrack.addEventListener('scroll', function () {
      if (peekTicking) return;
      peekTicking = true;
      requestAnimationFrame(function () {
        var w = peekTrack.firstElementChild ? peekTrack.firstElementChild.offsetWidth + 8 : 1;
        syncGallery(Math.min(feedImgs.length - 1, Math.round(peekTrack.scrollLeft / w)));
        peekTicking = false;
      });
    }, { passive: true });
  }

  /* ---------- variant picking: ALL options ----------
     One row per multi-value option (swatches for metal, pills for size).
     selections[] holds the chosen value per option index; a pick resolves the
     matching variant, updates the cart target, swaps the variant photo when
     one exists (no fake colour filters), and reprices every tier. */
  var baseVariantOverride = null;
  var baseColorValue = null;
  var selections = [];
  var variantData = null;
  (function initSelections() {
    var dataEl = document.getElementById('lcVariants');
    if (!dataEl) return;
    try { variantData = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.querySelectorAll('.opt-row').forEach(function (row) {
      var idx = parseInt(row.dataset.optIndex, 10);
      var active = row.querySelector('.active');
      if (active) selections[idx] = active.dataset.value;
      if (row.hasAttribute('data-opt-color') && active) baseColorValue = active.dataset.value;
    });
  })();

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function repriceTiers(v) {
    if (window.smSetBase) window.smSetBase(v.p);
    var mult = parseFloat(root.dataset.cmpMult) || 2;
    var baseComp = v.c > v.p ? v.c : Math.round(v.p * mult);
    root.querySelectorAll('.tier').forEach(function (t) {
      var pp = parseInt(t.dataset.pprice, 10) || 0;
      var now, was;
      if (pp > 0) {
        now = Math.round((v.p + pp) * 0.8);
        was = baseComp + (parseInt(t.dataset.pcomp, 10) || 0);
      } else {
        now = v.p;
        was = baseComp > v.p ? baseComp : 0;
      }
      t.dataset.price = (now / 100).toFixed(2);
      t.dataset.was = was ? (was / 100).toFixed(2) : '';
      var elNow = t.querySelector('.t-now'), elWas = t.querySelector('.t-was'), elSave = t.querySelector('.t-save');
      if (elNow) elNow.textContent = money(now);
      if (elWas) { elWas.textContent = was ? money(was) : ''; elWas.style.display = was ? '' : 'none'; }
      if (elSave) elSave.textContent = was ? 'Save ' + money(was - now) : '';
    });
    var checked = root.querySelector('.tier input:checked');
    if (checked) window.pickTier(checked, true);
  }

  window.pickOpt = function (el) {
    if (!variantData) return;
    var row = el.closest('.opt-row');
    var idx = parseInt(row.dataset.optIndex, 10);
    var value = el.dataset.value;
    var want = selections.slice();
    want[idx] = value;
    var match = variantData.find(function (v) {
      return v.available && v.opts.every(function (o, k) { return want[k] === undefined || o === want[k]; });
    }) || variantData.find(function (v) {
      return v.opts.every(function (o, k) { return want[k] === undefined || o === want[k]; });
    });
    if (!match) { toast('That combination is unavailable'); return; }
    selections = want;
    baseVariantOverride = String(match.id);
    /* Keep Buy Now (dynamic checkout form) pointed at the picked variant. */
    var buyNowId = root.querySelector('[data-buynow-id]');
    if (buyNowId) buyNowId.value = match.id;
    if (row.hasAttribute('data-opt-color')) baseColorValue = value;
    row.querySelectorAll('.swatch, .optpill').forEach(function (b) { b.classList.remove('active'); });
    el.classList.add('active');
    var picked = row.querySelector('.picked');
    if (picked) picked.textContent = value;
    if (match.img) {
      lastVariantImg = match.img;
      showImage(match.img);
    } else if (row.hasAttribute('data-opt-color') && defaultHero) {
      lastVariantImg = null;
      showImage(defaultHero);
    }
    repriceTiers(match);
    if (row.hasAttribute('data-opt-color')) syncTierMetalDefaults();
    toast(value + ' selected');
  };

  function withBase(ids) {
    if (!baseVariantOverride || !ids.length) return ids;
    var out = ids.slice();
    out[0] = baseVariantOverride;
    return out;
  }
  /* Metal-matching: if the shopper picked a metal on the base product and the
     bundle partner comes in that metal at the SAME price, swap the partner to
     it. Price-unequal or unavailable matches keep the curated variant, so the
     tier price shown is always the price charged. */
  function tierMap(tierEl) {
    var mapEl = tierEl && tierEl.querySelector('script.tier-pvmap');
    if (!mapEl) return null;
    try { return JSON.parse(mapEl.textContent); } catch (e) { return null; }
  }
  function resolvePartnerColor(tierEl, pinnedId, colorValue) {
    var d = tierMap(tierEl);
    if (!d) return null;
    var pinned = d.variants.find(function (v) { return String(v.id) === String(pinnedId); });
    if (!pinned) return null;
    return d.variants.find(function (v) {
      return v.a && v.p === pinned.p && v.opts[d.opt] === colorValue;
    }) || null;
  }
  /* Partner variant precedence: the shopper's explicit pick in the tier's
     inline metal row, else auto-follow the base metal, else the curated pin. */
  function withPartnerMatch(tierEl, ids) {
    if (!tierEl || ids.length < 2) return ids;
    if (tierEl.dataset.partnerVariant) {
      ids = ids.slice(); ids[1] = tierEl.dataset.partnerVariant; return ids;
    }
    if (!baseColorValue) return ids;
    var m = resolvePartnerColor(tierEl, ids[1], baseColorValue);
    if (m) { ids = ids.slice(); ids[1] = String(m.id); }
    return ids;
  }
  /* Inline metal row inside a bundle tier. Picking a metal also selects the
     tier (choosing a metal means you want that bundle). */
  window.pickTierMetal = function (el) {
    var t = el.closest('.tier');
    if (!t) return;
    var input = t.querySelector('input[type=radio]');
    if (input && !input.checked) { input.checked = true; window.pickTier(input); }
    var pinnedId = (t.dataset.variants || '').split(',')[1];
    var m = resolvePartnerColor(t, pinnedId, el.dataset.value);
    if (!m) { toast(el.dataset.value + ' is unavailable'); return; }
    t.dataset.partnerVariant = String(m.id);
    t.dataset.partnerChosen = '1';
    t.querySelectorAll('.tm-swatch').forEach(function (b) { b.classList.remove('active'); });
    el.classList.add('active');
    toast(el.dataset.value + ' selected for this piece');
  };
  /* Base metal changes re-default any tier row the shopper hasn't touched. */
  function syncTierMetalDefaults() {
    if (!baseColorValue) return;
    root.querySelectorAll('.tier').forEach(function (t) {
      if (t.dataset.partnerChosen === '1') return;
      var pinnedId = (t.dataset.variants || '').split(',')[1];
      if (!pinnedId) return;
      var m = resolvePartnerColor(t, pinnedId, baseColorValue);
      if (!m) return;
      var d = tierMap(t);
      t.querySelectorAll('.tm-swatch').forEach(function (b) {
        b.classList.toggle('active', b.dataset.value === m.opts[d.opt]);
      });
    });
  }

  /* ---------- bundle tiers ---------- */
  var tier = null;
  window.pickTier = function (input, keepHero) {
    var t = input.closest('.tier');
    root.querySelectorAll('.tier').forEach(function (x) { x.classList.remove('selected'); });
    t.classList.add('selected');
    tier = {
      el: t,
      label: t.dataset.label,
      price: parseFloat(t.dataset.price),
      was: t.dataset.was ? parseFloat(t.dataset.was) : null,
      variants: (t.dataset.variants || '').split(',').filter(Boolean)
    };
    var p = '$' + tier.price.toFixed(2);
    setText('atcPrice', p);
    setText('stickyPrice', p);
    var sub = document.getElementById('stickySub');
    if (sub) sub.innerHTML = tier.label + ' · ' + p + (tier.was ? ' <s style="color:var(--ink-faint)">$' + tier.was.toFixed(2) + '</s>' : '');

    setText('mainPrice', p);
    var cmpCol = document.getElementById('cmpCol');
    var saveNote = document.getElementById('mainSaveNote');
    if (tier.was) {
      setText('mainCompare', '$' + tier.was.toFixed(2));
      if (cmpCol) cmpCol.style.display = '';
      if (saveNote) {
        saveNote.textContent = 'You save $' + (tier.was - tier.price).toFixed(2);
        saveNote.style.display = '';
      }
    } else {
      if (cmpCol) cmpCol.style.display = 'none';
      if (saveNote) saveNote.style.display = 'none';
    }

    var gal = root.querySelector('.gallery') || root;
    if (gal.getBoundingClientRect().top < -40) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

    /* keepHero: a variant pick just set the hero to the variant's own photo
       (e.g. silver); re-picking the tier for a reprice must not stomp it.
       On a real tier click, the solo tier shows the picked variant's photo
       when it has one — the tier's own image is gold-led photography. */
    if (t.dataset.img && !keepHero) {
      var heroSrc = t.dataset.img;
      if (t.dataset.pprice === '0' && lastVariantImg) heroSrc = lastVariantImg;
      showImage(heroSrc);
      syncGallery(-1);
      var tag = document.getElementById('heroTag');
      if (tag) {
        if (t.dataset.set) { tag.textContent = t.dataset.set; tag.classList.add('on'); }
        else { tag.classList.remove('on'); syncGallery(0); gIdx = 0; }
      }
      var si = document.getElementById('stickyImg');
      if (si) { si.src = heroSrc; si.onerror = function () { phFix(si); }; }
      /* showImage already updated the peek slide; only the badge is tier-specific. */
      var ptag = document.getElementById('peekTag');
      if (ptag) {
        if (t.dataset.set) { ptag.textContent = t.dataset.set; ptag.classList.add('on'); }
        else { ptag.classList.remove('on'); }
      }
    }
  };
  function setText(id, v) { var el = document.getElementById(id); if (el) el.textContent = v; }

  /* ---------- Complete Your Stack ---------- */
  /* Additive add-ons over the base piece. All money in cents. The 2+ pieces
     -> 20% math mirrors checkout's automatic discount; every number shown
     (per-row delta, total, save) is derived live from the current selection. */
  var stackMod = document.getElementById('stackMod');
  var smBase = stackMod ? (parseInt(stackMod.dataset.basePrice, 10) || 0) : 0;
  var smAddons = [];
  if (stackMod) {
    smAddons = Array.prototype.slice.call(stackMod.querySelectorAll('[data-sm-addon]')).map(function (el) {
      var mapEl = el.querySelector('script.tier-pvmap');
      var map = null;
      if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) {} }
      return { el: el, price: parseInt(el.dataset.price, 10) || 0, variant: el.dataset.variant, map: map, added: false };
    });
  }

  function smMoney(c) { return '$' + (c / 100).toFixed(2); }

  function smDisc(list) {
    var sum = smBase, n = 1;
    list.forEach(function (a) { sum += a.price; n++; });
    return n >= 2 ? Math.round(sum * 0.8) : sum;
  }

  /* The add-on's variant, following the base metal when a price-equal,
     available match exists (same rule the old tiers used). */
  function smAddonVariant(a) {
    if (a.map && baseColorValue) {
      for (var i = 0; i < a.map.variants.length; i++) {
        var v = a.map.variants[i];
        if (v.a && v.p === a.price && String(v.opts[a.map.opt]).toLowerCase() === baseColorValue.toLowerCase()) {
          return String(v.id);
        }
      }
    }
    return String(a.variant);
  }

  function smSync() {
    if (!stackMod) return;
    var added = smAddons.filter(function (a) { return a.added; });
    var cur = smDisc(added);
    var raw = smBase + added.reduce(function (t, a) { return t + a.price; }, 0);

    smAddons.forEach(function (a) {
      /* Stable pairwise delta (this piece added to the base alone) — the
         number never shifts as other add-ons toggle. The summary total is
         the exact figure. */
      var d = smDisc([a]) - smBase;
      var dEl = a.el.querySelector('[data-sm-delta]');
      if (dEl) dEl.textContent = '+' + smMoney(d);
      a.el.classList.toggle('added', a.added);
      var btn = a.el.querySelector('[data-sm-toggle]');
      if (btn) {
        btn.textContent = a.added ? '\u2713' : '+';
        btn.setAttribute('aria-pressed', a.added ? 'true' : 'false');
      }
    });

    var baseEl = document.getElementById('smBasePrice');
    if (baseEl) baseEl.textContent = smMoney(smBase);
    var totalEl = document.getElementById('smTotal');
    if (totalEl) totalEl.textContent = smMoney(cur);
    var saveEl = document.getElementById('smSave');
    if (saveEl) saveEl.textContent = raw > cur ? '(Save ' + smMoney(raw - cur) + ')' : '';

    var minis = document.getElementById('smMinis');
    if (minis) {
      /* One composite photo: the latest-added pair shot, else the base piece. */
      var last = added.length ? added[added.length - 1].el.dataset : null;
      var src = last
        ? (last.flat || last.life || last.thumb)
        : stackMod.querySelector('.sm-base .sm-thumb').src;
      minis.innerHTML = '<img src="' + src + '" alt="">';
    }

    setText('atcPrice', smMoney(cur));
    setText('stickyPrice', smMoney(cur));
    var sub = document.getElementById('stickySub');
    if (sub) sub.textContent = (added.length + 1) + (added.length ? ' pieces' : ' piece') + ' \u00b7 ' + smMoney(cur);

    /* Hero follows the stack: last-added pair photo + a set badge. */
    var tag = document.getElementById('heroTag');
    var ptag = document.getElementById('peekTag');
    if (added.length) {
      var last = added[added.length - 1];
      if (last.el.dataset.life) showImage(last.el.dataset.life);
      var lbl = (added.length + 1) + '-piece set';
      if (tag) { tag.textContent = lbl; tag.classList.add('on'); }
      if (ptag) { ptag.textContent = lbl; ptag.classList.add('on'); }
    } else {
      showImage(lastVariantImg || defaultHero);
      if (tag) tag.classList.remove('on');
      if (ptag) ptag.classList.remove('on');
    }
  }
  window.smSync = smSync;
  /* Base price follows the variant picker. */
  window.smSetBase = function (cents) { smBase = cents; smSync(); };
  window.smCartIds = function () {
    var ids = [root.dataset.baseVariant];
    smAddons.forEach(function (a) { if (a.added) ids.push(smAddonVariant(a)); });
    return ids;
  };

  if (stackMod) {
    stackMod.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-toggle]');
      if (!btn) return;
      var row = btn.closest('[data-sm-addon]');
      for (var i = 0; i < smAddons.length; i++) {
        if (smAddons[i].el === row) { smAddons[i].added = !smAddons[i].added; break; }
      }
      smSync();
    });
    smSync();
  }

  /* ---------- the real cart ---------- */
  function cartAdd(variantIds, onDone) {
    var items = variantIds.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'error'); });
      return r.json();
    }).then(function () {
      openCartDrawer();
      if (onDone) onDone();
    }).catch(function (e) {
      toast(e.message === 'error' ? 'Could not add to bag' : e.message);
    });
  }
  /* UpCart monkey-patches fetch, sees our /cart/add.js call, refreshes its
     drawer and auto-opens it (verified: "[UPEZ] Open cart after add" in its
     console output). Its window.upcartOpenCart API needs undocumented args and
     throws when called bare, so we do NOT call it -- interception is the
     mechanism. The event below is a no-op fallback for non-UpCart setups. */
  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  window.addToCart = function () {
    if (stackMod) {
      cartAdd(withBase(window.smCartIds()), function () { toast('Added to your bag \u2728'); });
      return;
    }
    if (tier && tier.variants.length) {
      cartAdd(withPartnerMatch(tier.el, withBase(tier.variants)), function () { toast('Added to your bag ✨'); });
      return;
    }
    /* No bundle tiers on this product (no metafield): add the base variant. */
    var base = root.dataset.baseVariant;
    if (!base) { toast('Unavailable'); return; }
    cartAdd(withBase([base]), function () { toast('Added to your bag ✨'); });
  };

  window.quickAdd = function (variantId, name) {
    cartAdd([variantId], function () { toast((name || 'Item') + ' added ✨'); });
  };

  /* ---------- sticky ATC ---------- */
  var atcBtnEl = document.getElementById('atcBtn');
  var stickyEl = document.getElementById('stickyAtc');
  if (atcBtnEl && stickyEl) {
    window.addEventListener('scroll', function () {
      stickyEl.classList.toggle('on', atcBtnEl.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  /* ---------- countdowns ---------- */
  var cd = document.getElementById('countdown');
  if (cd) {
    var end = new Date(); end.setHours(23, 59, 59, 999);
    setInterval(function () {
      var d = Math.max(0, end - new Date());
      var z = function (x) { return (x < 10 ? '0' : '') + x; };
      cd.textContent = z(Math.floor(d / 36e5)) + ':' + z(Math.floor(d % 36e5 / 6e4)) + ':' + z(Math.floor(d % 6e4 / 1e3));
    }, 1000);
  }
  var eta = document.getElementById('etaCount');
  if (eta) {
    var cutoff = new Date(); cutoff.setHours(cutoff.getHours() + 4, cutoff.getMinutes() + 32);
    var tick = function () {
      var d = Math.max(0, cutoff - new Date());
      eta.textContent = Math.floor(d / 36e5) + 'h ' + Math.floor(d % 36e5 / 6e4) + 'm';
    };
    tick(); setInterval(tick, 30000);
  }

  /* dynamic delivery window: today+4 -> today+10 (from Jay's polish commit) */
  (function () {
    var m = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var a = new Date(); a.setDate(a.getDate() + 4);
    var b = new Date(); b.setDate(b.getDate() + 10);
    var s2 = m[a.getMonth()] + ' ' + a.getDate() + ' – ' + (a.getMonth() === b.getMonth() ? '' : m[b.getMonth()] + ' ') + b.getDate();
    root.querySelectorAll('.shipRange').forEach(function (el) { el.textContent = s2; });
  })();

  /* ---------- init ---------- */
  var initTier = root.querySelector('.tier input:checked');
  if (initTier) { window.pickTier(initTier); }
  if (window.matchMedia('(max-width:640px)').matches) {
    root.querySelectorAll('.accs details[open]').forEach(function (d) { d.removeAttribute('open'); });
  }
})();
